import React from 'react';
import {createContext, useContext} from 'react';

import {UseHistoryKeysQueryResult} from '../../state/graphql/historyKeysQuery';
import {useKeyInfoQuery} from '../../state/runs/hooks';
import * as RunSetTypes from '../../state/views/runSet/types';

const KeyInfoQueryContext = createContext<
  UseHistoryKeysQueryResult | undefined
>(undefined);

export const KeyInfoQueryContextProvider = ({
  children,
  runSetRefs,
}: {
  children: React.ReactNode;
  runSetRefs: RunSetTypes.Ref[];
}) => {
  const keyInfoQuery = useKeyInfoQuery(runSetRefs);
  return (
    <KeyInfoQueryContext.Provider value={keyInfoQuery}>
      {children}
    </KeyInfoQueryContext.Provider>
  );
};
KeyInfoQueryContextProvider.displayName = 'KeyInfoQueryContextProvider';

export const useKeyInfoQueryContext = () => {
  const context = useContext(KeyInfoQueryContext);

  if (!context) {
    throw new Error(
      'useKeyInfoQueryContext must be used within a KeyInfoQueryContextProvider'
    );
  }

  return context;
};
